import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/HeroSection";
import WhatThisAppDoes from "./components/WhatThisAppDoes";
import KeyFeatures from "./components/KeyFeatures";
import WhatYouCanReport from "./components/WhatYouCanReport";
import HowItWorks from "./components/HowItWorks";
import RewardsSection from "./components/RewardsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import DownloadAppSection from "./components/DownloadAppSection";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <WhatThisAppDoes />
      <KeyFeatures />
      <WhatYouCanReport />
      <HowItWorks />
      <RewardsSection />
      <TestimonialsSection />
      <DownloadAppSection />
      <Footer />
    </>
  );
}

export default App;
